import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useProviderSection } from "@/contexts/contact";
import { useI18n } from "@/contexts/i18n";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
export const AgencyLegalInfos = () => {
    var _a;
    const { t } = useI18n();
    const { agencyLegalInformations } = (_a = useProviderSection()) !== null && _a !== void 0 ? _a : {};
    if (!agencyLegalInformations || agencyLegalInformations.length === 0) {
        return null;
    }
    return (_jsxs(Box, { children: [_jsx(Box, { typography: "typography.body.14.bold", marginBottom: "spacing.8", children: t("provider.agency_legal_informations.title") }), _jsx(Box, { typography: "typography.body.12.regular", children: agencyLegalInformations.map((info) => (_jsx(Box, { dangerouslySetInnerHTML: { __html: info } }, info))) }), _jsx(Divider, { "aria-hidden": "true", marginVertical: "spacing.24" })] }));
};
